declare var jQuery: any;

class GravityForms {

	protected formEls: NodeListOf<HTMLElement>;

	constructor() {
		this.formEls = document.querySelectorAll(".gform_wrapper");

		if (this.formEls.length > 0) {
			this.formEls.forEach(item => {
				this.addCustomSpinner(item);
				this.createCustomFileInputs(item);
				this.moveRequiredLegendToBottom(item);
			});

			jQuery(document).on("gform_confirmation_loaded", this.onConfirmationLoaded.bind(this));
		}

	}

	protected slideIntoViewAfterSubmit(formId: number): void {
		const confirmationMsg = document.getElementById(`gform_confirmation_message_${formId}`);
		if (confirmationMsg instanceof HTMLElement) {
			const section = confirmationMsg.closest(".section");
			if (section instanceof HTMLElement) {
				section.scrollIntoView({
					behavior: "smooth"
				});
			}
		}
	}

	protected addCustomSpinner(formWrapper: HTMLElement) {
		const footerEl = formWrapper.querySelector(".gform_footer");
		const footerObserver = new MutationObserver((records) => {
			records.forEach(rec => {
				if (rec.addedNodes.length > 0) {
					rec.addedNodes.forEach(node => {
						if (node instanceof HTMLElement && node.classList.contains("gform_ajax_spinner")) {
							const btnEl = formWrapper.querySelector(".gform_submit_button");
							if (btnEl instanceof HTMLElement) {
								btnEl.classList.add("has-spinner");
								btnEl.append(node);
							}
						}
					});
				}
			});
		});

		const formObserver = new MutationObserver((records) => {
			if (this.wasSubmitted(records)) {
				this.addCustomSpinner(formWrapper); // since the DOM is rebuilt after submission
			}
		});

		if (footerEl instanceof HTMLElement) {
			footerObserver.observe(footerEl, {childList: true});
		}

		formObserver.observe(formWrapper, {childList: true});
	}

	protected wasSubmitted(records: MutationRecord[]): boolean {
		let out = false;
		records.forEach(rec => {
			if (rec.addedNodes.length > 0) {
				rec.addedNodes.forEach(node => {
					if (node instanceof HTMLFormElement) {
						out = true;
					}
				});
			}
		});

		return out;
	}

	protected createCustomFileInputs(formWrapper: HTMLElement): void {
		const fileInputEls = formWrapper.querySelectorAll("input[type=file]");
		if (fileInputEls.length === 0) {
			return;
		}

		fileInputEls.forEach(
			input => {
				if (input instanceof HTMLInputElement) {
					const labelElement = input.closest("form")?.querySelector("label[for=" + input.id + "]");
					const overlayEl = document.createElement("div");
					let label = "";
					if (labelElement instanceof HTMLElement) {
						label = labelElement.innerHTML;
						labelElement.style.display = "none";
					}
					else {
						label = "Browse...";
					}

					overlayEl.classList.add("upload-overlay");
					overlayEl.innerHTML = label;

					input.after(overlayEl);

					input.addEventListener("change", (e) => {
						const path = input.value;
						const dirSeparator = path.indexOf("\\") > -1 ? "\\" : "/";

						if (input.nextElementSibling instanceof HTMLElement) {
							input.nextElementSibling.innerHTML = String(path.split(dirSeparator).pop());
						}
					});
				}
			}
		);
	}

	protected moveRequiredLegendToBottom(formWrapper: HTMLElement): void {
		const legend = formWrapper.querySelector(".gform_heading .gform_required_legend");
		if (!(legend instanceof HTMLElement)) {
			return;
		}

		formWrapper.querySelector(".gform_body")?.append(legend);
	}

	protected onConfirmationLoaded(e: Event, formId: number): void {
		this.slideIntoViewAfterSubmit(formId);
	}
}

export default GravityForms;
